import '.i{position:fixed;}.ssr-plugin'
import '.b6{top:0px;}.ssr-plugin'
import '.be{left:0px;}.ssr-plugin'
import '.bf{right:0px;}.ssr-plugin'
import '.bg{bottom:0px;}.ssr-plugin'
import '.bh{background-color:rgba(0, 0, 0, 0.25);}.ssr-plugin'
import '.bi{z-index:998;}.ssr-plugin'
import '.bj{transition:opacity 0.3s ease;}.ssr-plugin'
import '.bk{height:100vh;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.t{background-color:var(--palette-white);}.ssr-plugin'
import '.bl{transition:transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);}.ssr-plugin'
import '.bm{z-index:999;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.bn{justify-content:space-between;}.ssr-plugin'
import '.bo{padding:1.5rem;}.ssr-plugin'
import '.bp{border-bottom:var(--border-default);}.ssr-plugin'
import '.ar{flex-shrink:0;}.ssr-plugin'
import '.b0{flex:1;}.ssr-plugin'
import '.bq{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { IconButton } from '@app/components/core/button/IconButton'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { PropsWithChildren } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'

export interface DrawerProps extends PropsWithChildren {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  portal?: HTMLElement
  style?: Style
  side: 'left' | 'right'
}

export const Drawer = ({
  title,
  open,
  setOpen,
  children,
  portal: _portal,
  style,
  side,
}: DrawerProps) => {
  const isMobile = useMediaQuery()

  const translateValue = open ? '0' : side === 'left' ? '-100%' : '100%'

  return (
    <>
      {/* Overlay */}
      <div className="i b6 be bf bg bh bi bj"
        onClick={() => setOpen(false)}
        style={{
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',}}
      />

      {/* Sidebar Panel */}
      <styled.div className="i b6 bk n t bl bm d e"
        style={{
          [side]: 0,
          maxWidth: isMobile ? '100%' : '30rem',
          borderRadius: isMobile ? 0 : '1.25rem',
          boxShadow: open ? '0 0 15px rgba(0,0,0,0.15)' : 'none',
          transform: `translateX(${translateValue})`,
          ...style,
        }}
      >
        {/* Header */}
        <div className="d r bn bo bp ar"
        >
          <Title.H4 style={{ margin: 0 }}>{title}</Title.H4>
          <IconButton
            icon={faXmark}
            size="small"
            variant="secondary"
            onClick={() => setOpen(false)}
          />
        </div>

        {/* Content */}
        <div className="b0 bq bo"
        >
          {children}
        </div>
      </styled.div>
    </>
  )
}
